/**
 * DROP DEAD — .dd-image-reveal observer
 * One-shot scroll-in reveal. Adds `is-revealed` when an element
 * enters the viewport, then unobserves it so it never re-animates.
 *
 * Reduced-motion users still get the class (for anything that wants
 * to listen for it), but the CSS side keeps them at final state.
 */
(function () {
  'use strict';

  var SELECTOR = '.dd-image-reveal:not(.is-revealed)';

  function revealImmediately(targets) {
    for (var i = 0; i < targets.length; i++) {
      targets[i].classList.add('is-revealed');
    }
  }

  function init() {
    var targets = document.querySelectorAll(SELECTOR);
    if (!targets.length) return;

    // No IntersectionObserver support (very old browsers) — just show everything.
    if (typeof IntersectionObserver === 'undefined') {
      revealImmediately(targets);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        }
      },
      {
        // Trigger a little before the element is fully in view so the
        // settle animation has room to breathe.
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.05,
      }
    );

    for (var j = 0; j < targets.length; j++) {
      observer.observe(targets[j]);
    }

    // Expose a hook so sections added later (e.g. via section-rendering
    // API or shopify:section:load) can register themselves.
    document.addEventListener('shopify:section:load', function (evt) {
      var nodes = evt.target.querySelectorAll(SELECTOR);
      for (var k = 0; k < nodes.length; k++) {
        observer.observe(nodes[k]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
